// Вспомогательные функции цветов/порогов и форматирование значений

export function getScoreColorByThreshold(score: number | null | undefined, minScore: number = 0): string {
  if (!score && score !== 0) return 'text-[#525866]';
  return score >= minScore ? 'text-[#38c793]' : 'text-[#df1c41]';
}

export function getPassedColor(isPassed: boolean): string {
  return isPassed ? 'text-[#38c793]' : 'text-[#df1c41]';
}


